var _g, _path, _g2, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnvelopeWithSearch = function SvgEnvelopeWithSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 83,
    viewBox: "0 0 77 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_b_727_1505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0429 62.5203L20.0898 55.8341C12.6039 53.8283 8.61619 48.7481 10.9563 40.0145L15.6367 22.5473C17.9768 13.8138 23.9704 11.408 31.4563 13.4139L56.4094 20.1C63.8953 22.1059 67.883 27.1861 65.5428 35.9197L60.8625 53.3868C58.5224 62.1204 52.5288 64.5261 45.0429 62.5203Z",
    fill: "#448AFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6686 40.138C35.5726 39.5763 33.6254 38.3593 32.3578 36.6022L26.219 28.2711C25.5944 27.4084 25.7589 26.1955 26.6216 25.5708C27.4844 24.9461 28.6973 25.1107 29.322 25.9734L35.4607 34.3045C36.9493 36.3347 40.1682 37.1973 42.4725 36.1833L51.9544 32.0378C52.9267 31.6029 54.091 32.0486 54.4942 33.0392C54.9291 34.0116 54.4834 35.1759 53.4928 35.5791L44.0109 39.7246C42.0595 40.6192 39.7647 40.6996 37.6686 40.138Z",
    fill: "#448AFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_727_1505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5798 73.9902L67.5627 67.9731C68.821 66.0526 69.5825 63.7348 69.5825 61.2514C69.5825 54.4966 64.0859 49 57.3311 49C50.5763 49 45.0798 54.4966 45.0798 61.2514C45.0798 68.0062 50.5763 73.5027 57.3311 73.5027C59.8145 73.5027 62.1323 72.7411 64.0528 71.4829L70.07 77.5C70.5667 77.9967 71.1958 78.2285 71.8249 78.2285C72.454 78.2285 73.0832 77.9967 73.5798 77.5C74.5401 76.5398 74.5401 74.9504 73.5798 73.9902Z",
    fill: "#448AFF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.283,
    cy: 81,
    rx: 32,
    ry: 2,
    fill: "#ACC4EE",
    fillOpacity: 0.55
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_727_1505",
    x: -1.71191,
    y: 0.750855,
    width: 79.9228,
    height: 74.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_727_1505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_727_1505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_727_1505",
    x: 42.0798,
    y: 46,
    width: 35.2202,
    height: 35.2285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_727_1505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_727_1505",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelopeWithSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "envelope-with-search.c1ddb0679ace572b708b1f6ce762cca3.svg";